/**
 * Layout Component
 * Main layout wrapper with sidebar and content area
 */

import React from 'react';
import Sidebar from './Sidebar';

function Layout({ children, activeTab, onTabChange, serverStatus }) {
  const styles = {
    layout: {
      display: 'flex',
      minHeight: '100vh',
      backgroundColor: '#FAFAFA',
    },
    main: {
      flex: 1,
      marginLeft: '240px', // Width of sidebar
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      transition: 'margin-left 0.2s ease-in-out',
    },
    header: {
      backgroundColor: '#FFFFFF',
      borderBottom: '1px solid #E8E8E8',
      padding: '20px 40px',
      position: 'sticky',
      top: 0,
      zIndex: 100,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    pageTitle: {
      fontSize: '20px',
      fontWeight: '600',
      color: '#111827',
      margin: 0,
      letterSpacing: '-0.025em',
    },
    content: {
      flex: 1,
      padding: '32px 40px',
      paddingBottom: '48px',
      maxWidth: '1400px',
      width: '100%',
      margin: '0 auto',
    },
  };

  // Page titles
  const pageTitles = {
    upload: 'Upload Receipt',
    statement: 'Bank Statement',
    manual: 'Add Expense',
    ask: 'Ask AI Assistant',
    expenses: 'Expenses',
    analytics: 'Analytics Dashboard',
    readme: 'Readme',
    currency: 'Currency Rates',
    feedback: 'Submit Feedback',
    settings: 'Settings',
    telegram: 'Telegram',
    privacy: 'Privacy',
    admin: 'Admin Panel',
  };

  // Responsive styles
  const responsiveStyles = `
    /* Prevent horizontal scroll on mobile */
    html, body {
      overflow-x: hidden;
      max-width: 100vw;
    }

    @media (max-width: 1024px) {
      .layout-main {
        margin-left: 200px !important; /* Slightly smaller sidebar margin for tablet */
      }
      .layout-content {
        padding: 24px 24px !important;
      }
    }

    @media (max-width: 768px) {
      .layout-main {
        margin-left: 0 !important;
        padding-top: 56px !important;
        padding-bottom: 80px !important;
        width: 100% !important;
        max-width: 100vw !important;
      }
      .layout-header {
        display: none !important;
      }
      .layout-content {
        padding: 20px 16px !important;
        padding-bottom: 88px !important;
        max-width: 100% !important;
        width: 100% !important;
        box-sizing: border-box !important;
      }
    }

    @media (max-width: 480px) {
      .layout-content {
        padding: 16px 12px !important;
        padding-bottom: 88px !important;
      }
    }
  `;

  return (
    <>
      <style>{responsiveStyles}</style>
      <div style={styles.layout}>
        <Sidebar
          activeTab={activeTab}
          onTabChange={onTabChange}
          serverStatus={serverStatus}
        />
        <main className="layout-main" style={styles.main}>
          <header className="layout-header" style={styles.header}>
            <h1 style={styles.pageTitle}>{pageTitles[activeTab] || 'Dashboard'}</h1>
          </header>
          <div className="layout-content" style={styles.content}>
            {children}
          </div>
        </main>
      </div>
    </>
  );
}

export default Layout;
